import React, { CSSProperties, ReactNode } from 'react'
import styled from 'styled-components'

interface DefaultProps {
  [key: string]: CSSProperties
}
const defaultProps: DefaultProps = {
  styleDefault: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '0',
    left: '0',
  },
  styleFollow: {
    position: 'fixed',
    right: '10px',
    bottom: '10px',
    width: '370px',
  },
}

interface FollowMeIframeProps {
  styleDefault?: CSSProperties
  styleFollow?: CSSProperties
  follow?: boolean
  ratio: string
  children: ReactNode
  className?: string
}
const FollowMeIframe = ({
  styleDefault = defaultProps.styleDefault,
  styleFollow = defaultProps.styleFollow,
  follow,
  ratio,
  children,
  className,
}: FollowMeIframeProps) => (
  <Container style={follow ? styleFollow : styleDefault} className={className}>
    <FollowMeIframeRatio ratio={ratio}>{children}</FollowMeIframeRatio>
  </Container>
)

export default FollowMeIframe

const Container = styled.div`
  filter: blur(0px);
  transition: filter 0.3s ease-in;

  &.blurred {
    filter: blur(5px);
    transition: filter 0.3s ease-in;

    &:after {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      z-index: 2;
      background-color: transparent;
      top: 0;
    }
  }
`

interface ContainerRatioProps {
  ratio: string
}
export const FollowMeIframeRatio = styled.div<ContainerRatioProps>`
  /* background: blue; */
  padding-bottom: ${({ ratio }) => ratio}%;
  height: 0;
  width: 100%;
  position: relative;
  overflow: hidden;

  embed,
  iframe,
  object,
  video {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
  }
`
